module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays.601a9b53.jpeg";